export const getAllStoresResMapper = {
    "[].id": "[].id",
    "[].svMarketPlaceId": "[].storeName",
    "[].marketplaceName": "[].marketplace",
    "[].accountStatus": "[].accountStatus",
    "[].lastStoreUpdatedOn":"[].lastUpdatedOn",
    "[].storeUpdateStatus":"[].storeUpdateStatus",
}